import {FC, PropsWithChildren} from "react";
import {Box, View} from "@unibuddy/patron";
import styled from "styled-components";

import {AuthLayout} from "./AuthLayout";
import background from "./image/star_background.png";

export const StyledBox = styled(Box)`
    height: 100%;
    overflow-y: scroll;
    &::-webkit-scrollbar {
        width: 0px;
        background: transparent;
    }
`;

export const DesktopAuthCarouselLayout: FC<PropsWithChildren> = ({children}) => {
    return <AuthLayout>{children}</AuthLayout>;
};

export const DesktopAuthLayout: FC<PropsWithChildren> = ({children}) => {
    return (
        <View flex="1" style={{backgroundImage: `url(${background})`}} minH="fit-content">
            <View flex="1" alignItems="center" justifyContent="center" minH={0}>
                <Box minW={["100%", 375]} maxW={700} w="40%" padding="medium" maxH="100vh">
                    <StyledBox
                        bgColor="white"
                        shadow="large"
                        borderRadius="xsmall"
                        position="relative"
                    >
                        {children}
                    </StyledBox>
                </Box>
            </View>
        </View>
    );
};
